// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-message_wrapper__NNJYo {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;

  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: max(8px, min(5%, 30px));
  align-items: center;
  justify-content: center;

  box-sizing: border-box;
  width: 100%;
  height: 100%;

  font-family: Montserrat, sans-serif;
  font-weight: 700;
  font-style: normal;
  color: var(--textColor);
  text-align: center;

  background: var(--backgroundColor); /* backwards compatible */

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@supports (color: color-mix(in lch, red, blue)) {
.error-message_wrapper__NNJYo {
  background: color-mix(in srgb, var(--backgroundColor) 75%, transparent);
}
}

.error-message_wrapper__NNJYo .error-message_link__4H4kJ {
  cursor: pointer;
  color: var(--primaryColor);
  -webkit-text-decoration: none;
  text-decoration: none;
}

.error-message_wrapper__NNJYo .error-message_link__4H4kJ:hover {
  -webkit-text-decoration: underline;
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/error-message/error-message.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,OAAO;;EAEP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,4BAAyB;EACzB,mBAAmB;EACnB,uBAAuB;;EAEvB,sBAAsB;EACtB,WAAW;EACX,YAAY;;EAEZ,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;;EAElB,kCAAkC,EAAE,yBAAyB;;EAG7D,mCAAmC;EACnC,kCAAkC;AACpC;;AA5BA;AAAA;EAwBE,uEAAuE;AAIzE;AAAA;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,6BAAqB;EAArB,qBAAqB;AACvB;;AAEA;EACE,kCAA0B;EAA1B,0BAA0B;AAC5B","sourcesContent":[".wrapper {\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  left: 0;\n\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: clamp(8px, 5%, 30px);\n  align-items: center;\n  justify-content: center;\n\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n\n  font-family: Montserrat, sans-serif;\n  font-weight: 700;\n  font-style: normal;\n  color: var(--textColor);\n  text-align: center;\n\n  background: var(--backgroundColor); /* backwards compatible */\n  background: color-mix(in srgb, var(--backgroundColor) 75%, transparent);\n\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.wrapper .link {\n  cursor: pointer;\n  color: var(--primaryColor);\n  text-decoration: none;\n}\n\n.wrapper .link:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `error-message_wrapper__NNJYo`,
	"link": `error-message_link__4H4kJ`
};
module.exports = ___CSS_LOADER_EXPORT___;
